import { render } from "./CustomDropdown.vue?vue&type=template&id=f59267fa&scoped=true"
import script from "./CustomDropdown.vue?vue&type=script&lang=js"
export * from "./CustomDropdown.vue?vue&type=script&lang=js"

import "./CustomDropdown.vue?vue&type=style&index=0&id=f59267fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59267fa"]])

export default __exports__